
export const OPEN_IMAGE_VIEWER = "OPEN_IMAGE_VIEWER";
export const CLOSE_IMAGE_VIEWER = "CLOSE_IMAGE_VIEWER";
